import { render } from "./ShopInfo.vue?vue&type=template&id=6cd9f502&scoped=true&bindings={\"item\":\"props\",\"hideBorder\":\"props\"}"
import script from "./ShopInfo.vue?vue&type=script&lang=js"
export * from "./ShopInfo.vue?vue&type=script&lang=js"

import "./ShopInfo.vue?vue&type=style&index=0&id=6cd9f502&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6cd9f502"

export default script